import { ADMIN_URLS } from "../../apiConfig.js";
import { ROLE_ERRORS } from "../../../common/constants/adminModule/roleConstants.js";
import apiClient from "../../apiInstance";

export const getUserRoles = async () => {
    try {
        const response = await apiClient.get(ADMIN_URLS.FETCH_ROLES);
        return response.data;
    } catch (error) {
        console.error(ROLE_ERRORS.FETCH_ROLES_ERROR, error);
        throw error;
    }
};

export const addUserRole = async (roleData) => {
    try {
        const response = await apiClient.post(`${ADMIN_URLS.ADD_USER_ROLE}`, roleData, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error(ROLE_ERRORS.ADD_ROLE_ERROR, error);
        throw error;
    }
};

export const editUserRole = async (roleData) => {
    try {
        const response = await apiClient.put(`${ADMIN_URLS.UPDATE_USER_ROLE}`, roleData);
        return response.data;
    } catch (error) {
        console.error(ROLE_ERRORS.UPDATE_ROLE_ERROR, error);
        throw error;
    }
};